import Vue from 'vue'

const state = {
  baseUri: '/botw/hn/check/'
}
const getters = {
}
const actions = {
  codes: function (_context, [paramData, callback]) { // 검색조건 조회
    const reqData = {
      year: paramData.year,
      month: paramData.month,
      contractCompSeq: paramData.contractCompSeq === null ? paramData.contractCompSeq : Number(paramData.contractCompSeq),
      visitCompSeq: paramData.visitCompSeq === null ? paramData.visitCompSeq : Number(paramData.visitCompSeq)
    }
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'codes',
      params: reqData
    }
    console.log('actions codes axiosOption : ', JSON.parse(JSON.stringify(axiosOption)))
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  search: function (_context, [paramData, callback]) { // 점검 현황 - 리스트 조회
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'search',
      params: paramData
    }
    console.log('actions search axiosOption : ', JSON.stringify(axiosOption.params))
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  pdfDown: function (_context, [paramData, callback]) { // 점검 현황 - pdf 정보 조회
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'pdfDown?',
      params: paramData
    }
    console.log('actions pdfDown axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  detail: function (_context, [historySeq, callback]) { // 상세조회
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'detail/' + historySeq
    }
    console.log('actions detail axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  update: function (_context, [paramData, callback]) { // 점검 현황 - 수정
    const reqData = {
      checkHistoryDtlList: paramData.checkHistoryDtlList,
      errList: paramData.errList,
      serverList: paramData.serverList
    }
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'update',
      data: reqData
    }
    console.log('actions update axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  updateStatus: function (_context, [paramData, callback]) { // 점검 현황 - 일괄 원격점검 상태 업데이트
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'updateStatus',
      data: paramData
    }
    console.log('actions updateStatus axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  officeUpdate: function (_context, [paramData, callback]) { // 점검 현황 - 완료 상태 업데이트
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'officeUpdate',
      data: paramData
    }
    console.log('actions officeUpdate axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  gimsPerUpdate: function (_context, [paramData, callback]) { // GIMS 정보 동기화
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'gimsPerformanceUpdate',
      params: paramData
    }
    console.log('actions gimsUpdate axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  officeUpdateFileCode: function (_context, [paramData, callback]) { // 현장 승인 및 파일 업데이트 이후 파일코드 백으로 전달
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'officeUpdateFileCode',
      data: paramData
    }
    console.log('actions officeUpdateFileCode axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  pdfDownZip: function (_context, [paramData, callback]) { // 보고서 일괄다운 압축파일
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'pdfDownZip',
      data: paramData,
      responseType: 'blob'
    }
    console.log('actions pdfDownZip axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  searchSpot: function (_context, [callback]) { // 점검 현황 - 수동 생성/삭제용 현장 리스트 조회
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'duruSpots'
    }
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  manualCreateCheck: function (_context, [paramData, callback]) { // 점검 현황 - 수동 생성
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'createCheck',
      data: paramData
    }
    console.log('actions pdfDownZip axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  manualDeleteCheck: function (_context, [paramData, callback]) { // 점검 현황 - 수동 삭제
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'deleteCheck',
      data: paramData
    }
    console.log('actions pdfDownZip axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  getCompUserList: function (_context, [paramData, callback]) { // 점검 현황 - 계약업체 직원, 방문업체 직원 조회
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'selectContVisitCheckUser',
      params: paramData
    }
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  updateCompUser: function (_context, [paramData, callback]) { // 점검 현황 - 계약업체 직원 변경 및 방문업체, 방문담당자 변경
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'updateCompUser',
      data: paramData
    }
    console.log('actions updateCompUser axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  }
}
const mutations = {
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
